export default {
  pick_favorites: "Escoge tus Favoritos",
  recommended: "Recomendados",
  category: "Categoria",
  author: "Autor",
  authors: "Autores"
}
  